import { przezmorzeApi, throwMessageOnStatuses } from "../../../api/api";
import type {
  CreateCustomerTagRequest,
  CustomerTag,
  CustomerTagCategory,
  CustomerTagListResponse,
  DeleteCustomerTagResponse,
  UpdateCustomerTagRequest,
} from "@przezmorze/api-types";

export type { CustomerTag, CustomerTagCategory, DeleteCustomerTagResponse };

export async function listCustomerTags(abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.get<CustomerTagListResponse>("/customer-tags", {
    signal: abortSignal,
  });
  return response.data.items;
}

export async function addCustomerTag(category: CustomerTagCategory, name: string, abortSignal?: AbortSignal) {
  const body: CreateCustomerTagRequest = { category, name };
  try {
    const response = await przezmorzeApi.post<CustomerTag>("/customer-tags", body, {
      signal: abortSignal,
    });
    return response.data;
  } catch (error) {
    throwMessageOnStatuses(error, [400, 409, 502]);
  }
}

export async function updateCustomerTag(
  id: string,
  category: CustomerTagCategory,
  name: string,
  abortSignal?: AbortSignal,
) {
  const body: UpdateCustomerTagRequest = { category, name };
  try {
    const response = await przezmorzeApi.put<CustomerTag>(`/customer-tags/${id}`, body, {
      signal: abortSignal,
    });
    return response.data;
  } catch (error) {
    throwMessageOnStatuses(error, [502]);
  }
}

export async function deleteCustomerTag(id: string, abortSignal?: AbortSignal) {
  try {
    const response = await przezmorzeApi.delete<DeleteCustomerTagResponse>(`/customer-tags/${id}`, {
      signal: abortSignal,
    });
    return response.data;
  } catch (error) {
    throwMessageOnStatuses(error, [502]);
  }
}
